<template lang="pug">
section.container.container_shrink.i_ptb_8
  .head
    h2.i_h2_title.text-center {{ title }}
    p.text-center.i_body_l {{ subTitle }}
  .row.i_mt_6
    .col-12.i_p_0
      swiper.swiper-container(:options="swiperOption", ref="mySwiper")
        swiper-slide.swiper-slide.d-flex.flex-column.align-items-center(
          v-for="(item, index) in content",
          :key="index"
        )
          item(:item="item")

      svg-icon.swiper-prev.d-none.d-md-block(
        iconClass="arrow_left_large",
        className="icon",
        @click="prevClick"
      )
      svg-icon.swiper-prev.d-md-none(
        iconClass="arrow_left_mobile",
        className="icon",
        @click="prevClick"
      )

      svg-icon.swiper-next.d-none.d-md-block(
        iconClass="arrow_right_large",
        className="icon",
        @click="nextClick"
      )
      svg-icon.swiper-next.d-md-none(
        iconClass="arrow_right_mobile",
        className="icon",
        @click="nextClick"
      )
</template>

<script>
import Item from "@/components/product/Intro/NormalIntro/Solution/Item";

export default {
  name: "Solution",
  props: {
    title: String,
    subTitle: String,
    content: Array,
  },
  components: {
    item: Item,
  },
  data() {
    var self = this;

    //初始slider可見個數
    let views;
    if (document.body.clientWidth <= 767) {
      views = 1;
    } else {
      views = 3;
    }

    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: views,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          resize: function () {
            self.updateSliders();
            this.update();
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    updateSliders() {
      if (document.body.clientWidth <= 767) {
        this.swiper.params.slidesPerView = 1;
      } else {
        this.swiper.params.slidesPerView = 3;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-next,
.swiper-prev {
  // @include square(40px);
  @include size(40px, 80px);

  cursor: pointer;
  z-index: 1;
}

.swiper-next {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateX(100%) translateX(20px) translateY(-50%);
}

.swiper-prev {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-100%) translateX(-20px) translateY(-50%);
}

@media (max-width: 991px) {
  .swiper-next,
  .swiper-prev {
    @include size(20px, 40px);
  }
}

@media (max-width: 767px) {
  section.container.container_shrink {
    max-width: 540px;
  }

  .swiper-next,
  .swiper-prev {
    @include size(40px, 40px);
    color: $color_sub_blue_ci;
  }

  .swiper-next {
    transform: translate(50%, -50%);
  }

  .swiper-prev {
    transform: translate(-50%, -50%);
  }
}

@media (max-width: 575px) {
  .container {
    padding-left: 30px;
    padding-right: 30px;
  }

  .swiper-next,
  .swiper-prev {
    @include square(7vw);
  }
}
</style>
